'use strict';

/* --- Scroll Reveal ---------------------------------------- */
const revealObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  },
  { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
);
document.querySelectorAll('.reveal').forEach((el) => revealObserver.observe(el));

/* --- Header scroll ---------------------------------------- */
const header = document.getElementById('SiteHeader');
const announcementBar = document.querySelector('.announcement-bar');

function updateHeader() {
  const threshold = announcementBar ? announcementBar.offsetHeight + 20 : 20;
  if (window.scrollY > threshold) {
    header?.classList.add('scrolled');
    header?.classList.remove('transparent');
  } else {
    header?.classList.remove('scrolled');
    header?.classList.add('transparent');
  }
}
if (header) {
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
}

/* --- Announcement bar offset ------------------------------ */
function setAnnouncementOffset() {
  const bar = document.querySelector('.announcement-bar');
  if (bar && header) header.style.top = `${bar.offsetHeight}px`;
}
setAnnouncementOffset();
window.addEventListener('resize', setAnnouncementOffset, { passive: true });

/* --- Mobile Navigation ------------------------------------ */
const mobileNav   = document.getElementById('MobileNav');
const mobileOpen  = document.getElementById('MobileNavOpen');
const mobileClose = document.getElementById('MobileNavClose');

function openMobileNav()  { mobileNav?.classList.add('is-open');    document.body.style.overflow = 'hidden'; }
function closeMobileNav() { mobileNav?.classList.remove('is-open'); document.body.style.overflow = ''; }

mobileOpen?.addEventListener('click', openMobileNav);
mobileClose?.addEventListener('click', closeMobileNav);

/* --- Cart Drawer ------------------------------------------ */
const cartDrawer   = document.getElementById('CartDrawer');
const cartOverlay  = document.getElementById('CartOverlay');
const cartClose    = document.getElementById('CartClose');

function openCart()  { cartDrawer?.classList.add('is-open');    cartOverlay?.classList.add('is-visible');    document.body.style.overflow = 'hidden'; }
function closeCart() { cartDrawer?.classList.remove('is-open'); cartOverlay?.classList.remove('is-visible'); document.body.style.overflow = ''; }

document.querySelectorAll('[data-cart-open]').forEach((btn) => btn.addEventListener('click', openCart));
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

/* --- Search Drawer ---------------------------------------- */
const searchDrawer = document.getElementById('SearchDrawer');
const searchClose  = document.getElementById('SearchClose');

function openSearch()  {
  searchDrawer?.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  searchDrawer?.querySelector('.search-input')?.focus();
}
function closeSearch() { searchDrawer?.classList.remove('is-open'); document.body.style.overflow = ''; }

document.querySelectorAll('[data-search-open]').forEach((btn) => btn.addEventListener('click', openSearch));
searchClose?.addEventListener('click', closeSearch);

/* --- Escape key closes all drawers ------------------------ */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { closeMobileNav(); closeCart(); closeSearch(); }
});

/* --- Money formatting (GBP) ------------------------------- */
function formatMoney(cents) {
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
}

/* --- Cart UI update --------------------------------------- */
function updateCartUI(cart) {
  const countEl    = document.querySelector('.cart-count');
  const subtotalEl = document.getElementById('CartSubtotal');
  if (countEl)    countEl.textContent    = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
}

/* --- Cart quantity buttons -------------------------------- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.qty-btn[data-key]');
  if (!btn) return;
  const key     = btn.dataset.key;
  const action  = btn.dataset.action;
  const itemRow = btn.closest('.cart-item');
  const qtyEl   = itemRow?.querySelector('span');
  if (!qtyEl) return;
  let qty = parseInt(qtyEl.textContent, 10);
  qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
  try {
    const res  = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    const cart = await res.json();
    updateCartUI(cart);
    if (qty === 0) itemRow.remove();
    else if (qtyEl) qtyEl.textContent = qty;
  } catch (err) { console.error('Cart update failed:', err); }
});

/* --- Cart item remove ------------------------------------- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.cart-item__remove');
  if (!btn) return;
  const key     = btn.dataset.key;
  const itemRow = btn.closest('.cart-item');
  try {
    const res  = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    const cart = await res.json();
    updateCartUI(cart);
    itemRow?.remove();
  } catch (err) { console.error('Cart remove failed:', err); }
});

/* --- Variant selection ------------------------------------ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.variant-btn');
  if (!btn) return;

  // Highlight selected button in this option group
  btn.closest('.variant-buttons')
     ?.querySelectorAll('.variant-btn')
     .forEach((b) => b.classList.remove('is-selected'));
  btn.classList.add('is-selected');

  // Collect all selected option values across all groups
  const form = btn.closest('.product-atc-form');
  if (!form) return;

  const selectedOptions = [];
  form.querySelectorAll('.variant-buttons').forEach((group) => {
    const active = group.querySelector('.variant-btn.is-selected');
    if (active) selectedOptions.push(active.dataset.value);
  });

  // Match against product variants JSON
  const variantsEl = document.getElementById('ProductVariantsJson');
  if (!variantsEl) return;
  const variants = JSON.parse(variantsEl.textContent);
  const match = variants.find((v) => selectedOptions.every((opt, i) => v.options[i] === opt));

  if (match) {
    // Update hidden variant ID
    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;

    // Update price display
    const details  = form.closest('.product-page__details');
    const priceEl  = details?.querySelector('.product-page__price');
    if (priceEl) {
      if (match.compare_at_price > match.price) {
        priceEl.innerHTML = `<span style="color:var(--color-text-muted);text-decoration:line-through;font-size:0.9rem;margin-right:10px;">${formatMoney(match.compare_at_price)}</span><span class="sale">${formatMoney(match.price)}</span>`;
      } else {
        priceEl.textContent = formatMoney(match.price);
      }
    }

    // Update add-to-cart button
    const addBtn = form.querySelector('[type="submit"]');
    if (addBtn) {
      addBtn.disabled    = !match.available;
      addBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
    }

    // Swap image if variant has a featured image
    if (match.featured_image) {
      const mainImg = document.querySelector('.product-gallery__main');
      if (mainImg) mainImg.src = match.featured_image.src;
    }
  }
});

/* --- Add to cart (product page) --------------------------- */
document.addEventListener('submit', async (e) => {
  const form = e.target.closest('.product-atc-form');
  if (!form) return;
  e.preventDefault();

  const submitBtn  = form.querySelector('[type="submit"]');
  const origText   = submitBtn?.textContent;
  if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

  const formData = new FormData(form);
  const id       = formData.get('id');
  const quantity = parseInt(formData.get('quantity') || '1', 10);

  try {
    const res = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id, quantity }),
    });
    if (res.ok) {
      const cart = await (await fetch('/cart.js')).json();
      updateCartUI(cart);
      openCart();
      showToast('Added to your bag');
    } else {
      const err = await res.json();
      showToast(err.description || 'Could not add item. Please try again.');
    }
  } catch {
    showToast('Something went wrong. Please try again.');
  } finally {
    if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
  }
});

/* --- Quick-add (product cards) ---------------------------- */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.product-card__quick-add');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const handle  = btn.dataset.productHandle;
  if (!handle) return;
  const origText = btn.textContent;
  btn.textContent = '…';
  btn.disabled = true;

  try {
    const productRes = await fetch(`/products/${handle}.js`);
    const product    = await productRes.json();
    const variant    = product.variants.find((v) => v.available) || product.variants[0];
    if (!variant) { showToast('Item unavailable'); return; }

    const addRes = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variant.id, quantity: 1 }),
    });
    if (addRes.ok) {
      const cart = await (await fetch('/cart.js')).json();
      updateCartUI(cart);
      openCart();
      showToast(`${product.title} added to your bag`);
    } else {
      showToast('Could not add item');
    }
  } catch {
    showToast('Something went wrong');
  } finally {
    btn.textContent = origText;
    btn.disabled    = false;
  }
});

/* --- Product gallery thumbnail swap ----------------------- */
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.product-thumb');
  if (!thumb) return;
  const gallery = thumb.closest('.product-page__gallery');
  const main    = gallery?.querySelector('.product-gallery__main');
  if (main && thumb.dataset.src) main.src = thumb.dataset.src;
});

/* --- Toast ------------------------------------------------ */
let toastTimeout;
function showToast(message, duration = 3000) {
  let toast = document.querySelector('.toast');
  if (!toast) { toast = document.createElement('div'); toast.className = 'toast'; document.body.appendChild(toast); }
  toast.textContent = message;
  clearTimeout(toastTimeout);
  toast.classList.add('is-visible');
  toastTimeout = setTimeout(() => toast.classList.remove('is-visible'), duration);
}

/* --- Marquee duplication ---------------------------------- */
document.querySelectorAll('.marquee-track').forEach((track) => {
  track.innerHTML += track.innerHTML;
});
